module.exports = __webpack_public_path__ + "static/img/1-lanse.3de5dec3.png";